"use strict";
var ipv4 = !1,
  ipv6 = !1,
  LC_API = LC_API || {};
(LC_API.on_after_load = function () {
  isMobile && (LC_API.hide_chat_window(), $("a.icon-livechat").show()),
    setInterval(function () {
      isMobile &&
        (LC_API.chat_window_maximized()
          ? $("a.icon-livechat").hide()
          : LC_API.chat_window_hidden()
          ? $("a.icon-livechat").show()
          : (LC_API.hide_chat_window(), $("a.icon-livechat").show()));
    }, 450);
}),
  (window.__lc = window.__lc || {}),
  (window.__lc.license = 14863323),
  (window.__lc.chat_between_groups = false),
  (window.__lc.visitor = { name: "Khách" }),
  (window.__lc.params = [
    { name: "Login", value: "Khách" },
    { name: "Domain", value: window.location.hostname },
  ]),
  (function () {
    var i = document.createElement("script");
    (i.type = "text/javascript"),
      (i.async = !0),
      (i.src =
        ("https:" == document.location.protocol ? "https://" : "http://") +
        "cdn.livechatinc.com/tracking.js");
    var n = document.getElementsByTagName("script")[0];
    n.parentNode.insertBefore(i, n);
  })(),
  $(document).ready(function () {
    $("a.icon-livechat,a#forgot-pwd").on("click", function () {
      LC_API.open_chat_window();
    });
  });
